/* eslint-disable import/first */
import React, { Children, useCallback, useState } from 'react';
import ClassNames from 'classnames';
import { navigate, useLocation } from '@reach/router';
import { FaAngleLeft } from '@react-icons/all-files/fa/FaAngleLeft';
import { useIntl } from 'react-intl';
import CartButton from '../CartButton';

import css from './index.module.scss';

const Section = ({ children, className }) => (
  <React.Fragment>
    {Children.count(children) ? <div {...{ className }}>{children}</div> : ''}
  </React.Fragment>
);

const MobileHeader = React.forwardRef((props, ref) => {
  const [isSticky, setIsSticky] = useState(false);
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      setIsSticky(scrollPosition > 35);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const intl = useIntl();
  const onExitMemoized = useCallback(
    (e) => {
      const windowLength = window.history.length;

      if (windowLength < 3) {
        navigate(`/${intl.locale}/home`);
      } else {
        navigate(-1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const {
    icon = <FaAngleLeft onClick={onExitMemoized} />,
    title = '',
    actionButtons = [],
    secondaryBar = '',
    cart = <CartButton />,
    className = '',
  } = props;
  const location = useLocation();
  return (
    <header
      className={ClassNames(className, css.root, isSticky ? css.stickyheader : '')}
      ref={ref || null}
    >
      <Section className={ClassNames(css.primaryBar, props.page === 'home' ? css.homeHeader : '')}>
        <Section className={css.iconSection}>{icon}</Section>
        {!props.searchBar && (
          <>
            <Section className={css.titleSection}>
              {title}{' '}
              {props?.tellNumber && (
                <>
                  - &nbsp; <a href={`tel:${props.tellNumber}`}>{props.tellNumber}</a>
                </>
              )}
            </Section>
          </>
        )}
        <Section
          className={ClassNames(css.actionButtonSection, {
            [css.searchBarSection]: props.searchBar,
          })}
        >
          {actionButtons.map(
            (actionButton, idx) =>
              actionButton &&
              React.cloneElement(actionButton, {
                key: `actionButton-${actionButton.type.name}`,
                className: ClassNames(actionButton.props.className, css.actionButton),
              })
          )}
        </Section>
      </Section>
      <Section className={css.secondaryBarSection}>{secondaryBar}</Section>
      {location?.pathname.includes('/home') && (
        <Section className={css.cartSection}>{cart}</Section>
      )}
    </header>
  );
});

export default MobileHeader;
